import { isNonEmptyTextNode, isTextNode } from 'anodum';
import isMediaElement from './is-media-element';
import isBreakElement from './is-break-element';
import { BREAK_TAG, IMAGE_TAG } from '../constants/editable-elements';

const hasNodeContent = (el) => {
  if (isTextNode(el)) {
    return isNonEmptyTextNode(el);
  }
  return (
    isMediaElement(el) ||
    isBreakElement(el) ||
    Boolean(el.innerText) ||
    Boolean(el.querySelector([BREAK_TAG, IMAGE_TAG]))
  );
};

export default hasNodeContent;
